/** a closed account's email, as fed-lib closeAccount rewrites it: 00_DELETED_<date>_<user>___<domain> */
const DELETED_EMAIL = /^00_DELETED_(\d{4}-\d{2}-\d{2})_(.*)$/;

/** the email as the customer had it, and the day the account closed (undefined for an open account) */
export function readEmail(customer) {
  const match = DELETED_EMAIL.exec(customer.email || '');
  if (match) {
    const [, deletedOn, rewritten] = match;
    return {email: rewritten.replace('___', '@'), deletedOn};
  }
  return {email: customer.email || ''};
}

/**
 * The customers an email search returned, in the order to offer them: open accounts first, then
 * closed ones newest first. Only the accounts whose email is the one typed count, unless no
 * account has it exactly, in which case every (partial) match is offered in the same order.
 */
export function rankCustomerMatches(customers, typed) {
  const wanted = typed.trim().toLowerCase();
  const read = customers.map(customer => ({customer, ...readEmail(customer)}));
  const exact = read.filter(({email}) => email.toLowerCase() === wanted);
  const offered = exact.length > 0 ? exact : read;
  return offered
    .map((entry, index) => ({...entry, index}))
    .sort((a, b) => {
      if (Boolean(a.deletedOn) !== Boolean(b.deletedOn)) {
        return a.deletedOn ? 1 : -1;
      }
      if (a.deletedOn && a.deletedOn !== b.deletedOn) {
        return a.deletedOn < b.deletedOn ? 1 : -1;
      }
      return a.index - b.index;
    })
    .map(({customer, email, deletedOn}) => ({...customer, email, deletedOn}));
}
